import { AssetInfo } from '../models/AssetInfo';

export const spfAsset: AssetInfo = {
  name: 'Spf',
  ticker: 'SPF',
  id: '9a06d9e545a41fd51eeffc5e20d818073bf820c635e2a9d922269913e0de369d',
  decimals: 6,
};
